// Extract hour from LTSS time format (e.g., "10/25/2025 10:30PM")
export function extractHour(timeStr: string | null): number | null {
  if (!timeStr) return null;
  const match = timeStr.match(/(\d{1,2}):(\d{2})(AM|PM)/i);
  if (!match) return null;
  
  let hour = parseInt(match[1]);
  const isPM = match[3].toUpperCase() === 'PM';
  
  if (isPM && hour !== 12) hour += 12;
  if (!isPM && hour === 12) hour = 0;
  
  return hour;
}

// Get month string from service date
export function getMonthKey(serviceDate: Date | null, startTime: string | null): string {
  if (serviceDate) {
    return serviceDate.toISOString().substring(0, 7);
  }
  // Try to parse from startTime
  if (startTime) {
    const match = startTime.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if (match) {
      return `${match[3]}-${match[1]}`;
    }
  }
  return 'unknown';
}

// Format currency
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Format percentage
export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

// Format hours
export function formatHours(hours: number): string {
  return `${hours.toFixed(1)} hrs`;
}

// Parse date range from week string
export function parseDateRange(weekStr: string): { start: Date | null; end: Date | null } {
  const match = weekStr.match(/(\d{2}\/\d{2}\/\d{4})\s*-\s*(\d{2}\/\d{2}\/\d{4})/);
  if (!match) return { start: null, end: null };
  
  const parseDate = (str: string): Date | null => {
    const parts = str.split('/');
    if (parts.length !== 3) return null;
    return new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
  };
  
  return {
    start: parseDate(match[1]),
    end: parseDate(match[2]),
  };
}
